import React from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getTeamRouterLink} from "root/Wieldy/routePaths";
import {UserTypeFilters, UserTypeTitles} from "root/DataFunctions/Constants";
import queryString from "query-string";
import {useLocation} from "react-router-dom";
import {useParams} from "react-router";

const TeamUsersSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const user_filter_type = queryParams.user_type === undefined ? UserTypeFilters.STAFF : queryParams.user_type;

    let { team_id } = useParams();
    const enc_team_id = team_id === undefined ? props.team_id : team_id ;
    //const enc_team_id = encodeURIComponent(team_id) ;

    return (

        <AppSidebarGroup title='Members' default={user_filter_type}>
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.STAFF)} title={UserTypeTitles.STAFF} iconName='icon-user-o' name={UserTypeFilters.STAFF} default={true}/>
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.CHILDREN)} title={UserTypeTitles.CHILDREN}  iconName='icon-user-o' name={UserTypeFilters.CHILDREN} />
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.FOSTER_CARERS)} title={UserTypeTitles.FOSTER_CARERS} iconName='icon-user-o' name={UserTypeFilters.FOSTER_CARERS} />
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.FOREVER_PARENTS)} title={UserTypeTitles.FOREVER_PARENTS} iconName='icon-user-o' name={UserTypeFilters.FOREVER_PARENTS} />
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.CONNECTED_CARERS)} title={UserTypeTitles.CONNECTED_CARERS} iconName='icon-user-o' name={UserTypeFilters.CONNECTED_CARERS} />
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.BIRTH_PARENTS)} title={UserTypeTitles.BIRTH_PARENTS}  iconName='icon-user-o' name={UserTypeFilters.BIRTH_PARENTS} />
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.PROFESSIONALS)} title={UserTypeTitles.PROFESSIONALS}  iconName='icon-user-o' name={UserTypeFilters.PROFESSIONALS} />
            <AppSidebarMenuItem link={getTeamRouterLink(enc_team_id, 'users?user_type=' + UserTypeFilters.OTHERS)} title={UserTypeTitles.OTHERS}  iconName='icon-user-o' name={UserTypeFilters.OTHERS} />
        </AppSidebarGroup>
    )
}

export default TeamUsersSubmenu ;